module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseModal', {
    attrs: {
      "class-name": 'ConfigurationModal',
      "title": 'CONFIGURATION__CONFIGURATION'
    },
    on: {
      "save": _vm.save,
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "ConfigurationModal__signout-container"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'CONFIGURATION__SIGN_OUT',
      "class-name": 'ConfigurationModal__signout'
    },
    on: {
      "click": function($event) {
        _vm.confirmSignout()
      }
    }
  })], 1), _vm._v(" "), _c('BaseDropdown', {
    attrs: {
      "label": 'CONFIGURATION__TIMEZONE',
      "value": _vm.timezone,
      "items": _vm.timezones,
      "errors": _vm.errors['timezone']
    },
    on: {
      "change": function($event) {
        _vm.setTimezone($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseLabel', {
    attrs: {
      "text": 'CONFIGURATION__LANGUAGE'
    }
  }), _vm._v(" "), _c('BaseSegmented', {
    attrs: {
      "value": _vm.culture,
      "items": _vm.cultures
    },
    on: {
      "change": _vm.setCulture
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59290003"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/ConfigurationModal.vue
// module id = 559
// module chunks = 1